export default __webpack_public_path__ + "static/4_16-a38d4118dbc032b8482ba53f59270dbd.png";